import React, { useEffect, useState, Fragment } from 'react';
import { toast } from 'react-toastify';
import api from '../../config/axios';
import Breadcrumb from '../common/breadcrumb';
import { date } from '../../utils/date';
import { Target } from 'react-feather';

const AllLeads = () => {
    const [leads, setLeads] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterUser, setFilterUser] = useState('');
    const [filterStatus, setFilterStatus] = useState('');

    useEffect(() => {
        fetchLeads();
    }, []);

    const fetchLeads = async () => {
        try {
            let url = '/lead/all';
            const params = [];
            if (filterUser) params.push(`userId=${filterUser}`);
            if (filterStatus) params.push(`status=${filterStatus}`);
            if (params.length) url += '?' + params.join('&');
            const { data } = await api.get(url);
            setLeads(data.data || []);
        } catch (err) {
            toast.error('Error al cargar los leads');
        } finally {
            setLoading(false);
        }
    };

    const handleFilter = (e) => {
        e.preventDefault();
        setLoading(true);
        fetchLeads();
    };

    return (
        <Fragment>
            <Breadcrumb title="Leads" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card">
                            <div className="card-body">
                                <form className="form-inline mb-3" onSubmit={handleFilter}>
                                    <div className="form-group mr-3">
                                        <label className="mr-2">Repartidor:</label>
                                        <select
                                            className="form-control"
                                            value={filterUser}
                                            onChange={(e) => setFilterUser(e.target.value)}
                                        >
                                            <option value="">Todos</option>
                                        </select>
                                    </div>
                                    <div className="form-group mr-3">
                                        <label className="mr-2">Estado:</label>
                                        <select
                                            className="form-control"
                                            value={filterStatus}
                                            onChange={(e) => setFilterStatus(e.target.value)}
                                        >
                                            <option value="">Todos</option>
                                            <option value="creado">Pendiente</option>
                                            <option value="convertido">Convertido</option>
                                        </select>
                                    </div>
                                    <button type="submit" className="btn btn-primary">
                                        Filtrar
                                    </button>
                                </form>

                                {loading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Cargando...</span>
                                        </div>
                                    </div>
                                ) : leads.length === 0 ? (
                                    <div className="text-center py-5">
                                        <p style={{ fontSize: 18, color: '#777' }}>
                                            No hay leads registrados
                                        </p>
                                    </div>
                                ) : (
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-hover">
                                            <thead>
                                                <tr>
                                                    <th>Repartidor</th>
                                                    <th>Nombre del lead</th>
                                                    <th>Teléfono</th>
                                                    <th>Observación</th>
                                                    <th>Fecha de captura</th>
                                                    <th>Estado</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {leads.map((lead) => (
                                                    <tr key={lead.id}>
                                                        <td>
                                                            {lead.user
                                                                ? `${lead.user.name} ${lead.user.lastName || ''}`.trim()
                                                                : 'Desconocido'}
                                                        </td>
                                                        <td>{lead.name}</td>
                                                        <td>{lead.phone}</td>
                                                        <td>{lead.observation || '-'}</td>
                                                        <td>{date(lead.createdAt)}</td>
                                                        <td>
                                                            {lead.status === 'creado' ? (
                                                                <span className="badge badge-warning">
                                                                    Pendiente
                                                                </span>
                                                            ) : (
                                                                <span className="badge badge-success">
                                                                    Convertido ✅
                                                                </span>
                                                            )}
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export default AllLeads;
